<template>
  <form @submit.prevent="onSubmit">
    <div class="row mb-3" v-if="!nonePassword">
      <label for="currentPassword" class="col-md-4 col-lg-3 col-form-label">Текущий пароль</label>
      <div class="col-md-8 col-lg-9">
        <input v-model="local.password" required name="password" type="password" class="form-control" id="currentPassword">
      </div>
    </div>

    <div class="row mb-3">
      <label for="newPassword" class="col-md-4 col-lg-3 col-form-label">Новый пароль</label>
      <div class="col-md-8 col-lg-9">
        <input v-model="local.newPassword" required name="newpassword" type="password" class="form-control" id="newPassword">
      </div>
    </div>

    <div class="row mb-3">
      <label for="renewPassword" class="col-md-4 col-lg-3 col-form-label">Повторите новый пароль</label>
      <div class="col-md-8 col-lg-9">
        <input v-model="local.newPassword2" required name="renewpassword" type="password" class="form-control" id="renewPassword">
      </div>
    </div>

    <div v-if="error" class="invalid-feedback" style="display: block" v-html="error"></div>
    <div v-if="success" class="text-center small" style="display: block; color: green" v-html="success"></div>
    <br>
    <div class="text-center">
      <span v-if="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <button type="submit" class="btn btn-primary" :disabled="loading">Сохранить</button>
    </div>
  </form>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { usePersonal } from '@/features/personal/composables/usePersonal';
import {onMounted, reactive, ref} from "vue";
import {normalizeAmountInput} from "@/api/helpers";

const route = useRoute();
const { changePassword, isNonePassword } = usePersonal();
const error = ref('');
const success = ref(false);
const loading = ref(false);
const local = reactive({
  password: '',
  newPassword: '',
  newPassword2: ''
});

const nonePassword = ref(false);
onMounted(async () => {
  nonePassword.value = await isNonePassword();
});

async function onSubmit() {
  error.value = '';
  success.value = '';
  if (local.newPassword !== local.newPassword2) {
    error.value = "Пароли не совпадают";
    return;
  }
  try {
    loading.value = true;
    await changePassword(local.password, local.newPassword);
    success.value = "Задан новый пароль";
    nonePassword.value = false;
  } catch (e) {
    error.value = "Произошла ошибка";
    if (e?.details) {
      e.details.forEach(function (err)  {
        if (err.field === 'newPassword') {
          error.value = 'Новый пароль должен содержать мин одну цифру, одну букву и иметь длину более 8 символов';
        }
      });
    }
    if (e?.code === "invalid_credentials") {
      error.value = 'Неверный текущий пароль';
    }
  } finally {
    loading.value = false;
  }
}
</script>

<style scoped>

</style>